module.exports = __webpack_public_path__ + "web/img/level-1.43388c89.png";